export default __webpack_public_path__ + "media/images/brands/kitchen-aid-a951d19ababeb2b21264d4dc3a4a488d.png";